import { Card, CardContent, Button, Box, Typography } from '@mui/material'
import { ImageList, ImageListItem } from '@mui/material'
import { toast } from 'react-toastify'
import { getBackendUserUrl, getCurrentUser } from 'utils/utils'
import axios from 'axios'

export default function VenueSpaceCard({
    venueSpace,
    addSpaceToCart,
    existingSpacesCart,
    setOpenVenueSpacesCard,
}) {
    const {
        title,
        startingPrice,
        entireSpace,
        imagesUrl = null,
        floorplanImageUrl = null,
    } = venueSpace

    const allImages = [
        ...(imagesUrl || []),
        ...(floorplanImageUrl || [])
    ].filter(Boolean)

    const hasImages = allImages.length > 0

    const handleAddingSpaceToCart = async () => {
        // Send request to backend to add space to cart
        const user = await getCurrentUser()
        if (user) {
            const backendUserUrl =
                getBackendUserUrl() + '/cart/add_space_to_cart'
            const requestBody = {
                user_id: user.userId,
                venue_id: venueSpace.venueId,
                venue_space_id: venueSpace.venueSpaceId,
            }

            try {
                // Send the POST request to the backend
                const response = await axios.post(backendUserUrl, requestBody)

                // If successful, you can show a success message (optional)
                toast.success(response.data.message)
                // Add space to the cart if not already there
                addSpaceToCart([...existingSpacesCart, venueSpace])
                return true
            } catch (err) {
                if (err.response && err.response.data) {
                    // Check for the error response data from the backend
                    const errorDetail = err.response.data.detail

                    // Handle different error codes and show corresponding error message
                    switch (errorDetail) {
                        case 'UserNotFound':
                            toast.error(
                                'User not found. Please make sure you are logged in.'
                            )
                            break
                        case 'SpaceAlreadyExistsInCart':
                            toast.error('This space is already in your cart.')
                            break
                        case 'DifferentVenueError':
                            toast.error(
                                'You cannot add items from this venue while you have a different venue in your cart.'
                            )
                            break
                        case 'AddOnAlreadyExistsInCart':
                            toast.error('This add-on is already in your cart.')
                            break
                        default:
                            toast.error(
                                'Something went wrong. Please try again later.'
                            )
                            break
                    }
                    return false
                } else {
                    toast.error(
                        'An unexpected error occurred. Please try again later.'
                    )
                    return false
                }
            }
        } else {
            toast.error('Please login to be able to add space to your cart')
        }
    }

    console.log("has images: ", hasImages, allImages)
    return (
        <Card sx={{ maxWidth: 600, boxShadow: 3, borderRadius: 2 }}>
            {hasImages && (
                <Box sx={{ width: '100%', height: 250, overflow: 'hidden' }}>
                    <ImageList
                        sx={{ width: '100%', height: 250 }}
                        cols={1}
                        rowHeight={250}
                    >
                        {allImages.map((image, index) => (
                            <ImageListItem key={index}>
                                <img
                                    src={image}
                                    alt={`Venue image ${index + 1}`}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                    }}
                                />
                            </ImageListItem>
                        ))}
                    </ImageList>
                </Box>
            )}
            <CardContent>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {title}
                </Typography>
                {startingPrice !== null ? (
                    <Typography variant="body1" color="textPrimary">
                        Starting at ${startingPrice}
                    </Typography>
                ) : (
                    <Typography variant="body1" color="textSecondary">
                        Price available upon request.
                    </Typography>
                )}
                <Typography variant="body2" color="textSecondary" mt={2}>
                    {entireSpace}
                </Typography>
                {startingPrice !== null ? (
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{ mt: 3 }}
                        onClick={() => {
                            // Check if the venueSpace already exists in the cart
                            const isSpaceInCart = existingSpacesCart.some(
                                (space) => space.id === venueSpace.venueSpaceId
                            )

                            if (isSpaceInCart) {
                                // Show toast notification if space is already in the cart
                                toast.error(
                                    'This venue is already in the cart.'
                                )
                            } else {
                                // This sends a backend request, and **also** updates the UI.
                                handleAddingSpaceToCart()
                            }

                            // And close the modal dialog
                            setOpenVenueSpacesCard(null)
                        }}
                    >
                        Add to Cart
                    </Button>
                ) : (
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{ mt: 3 }}
                    >
                        Request pricing information.
                    </Button>
                )}
            </CardContent>
        </Card>
    )
}
